import { Audited } from '@ianesthesie-kit/services';
import { GroupedList } from '@/util';

export enum ConsultationStatCode {
  HEIGHT_CM = 'HEIGHT_CM',
  WEIGHT_KG = 'WEIGHT_KG',
  BMI = 'BMI',
  IDEAL_VENTILATION = 'IDEAL_VENTILATION',
  MAX_BLOOD_LOSS = 'MAX_BLOOD_LOSS',
  MAX_PREDICTED_HEART_RATE = 'MAX_PREDICTED_HEART_RATE',
  IDEAL_WEIGHT = 'IDEAL_WEIGHT',
  TOTAL_BLOOD_MASS = 'TOTAL_BLOOD_MASS'
}

export interface ConsultationStat extends Audited {
  code: ConsultationStatCode | string;
  value: number;
}

export type GroupedConsultationStats = GroupedList<
  ConsultationStat,
  ConsultationStatCode | string,
  false
>;
